import { render, staticRenderFns } from "./ScaleButtons.vue?vue&type=template&id=9f8f79f0&"
import script from "./ScaleButtons.vue?vue&type=script&lang=js&"
export * from "./ScaleButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports